import axios from 'axios';
import { DC_FORM_SENDER_APPLICATIONS } from '@alfa-bank/site-dc-env-config';

import type { IInitOrderResponse } from '../models/api';
import type { IFirstStepData } from '../models/form-data';

export const initOrderApi = (formData: IFirstStepData) => {
    return axios.post<IInitOrderResponse>(DC_FORM_SENDER_APPLICATIONS(), formData);
};
